import type { FaireProductEntity } from "../../entity_types/product";

export const p_9vxn7dbzyx: FaireProductEntity = {
  token: "p_9vxn7dbzyx",
  type: "product",
  name: "Amber Apothecary Soy Candle 8 Ounces",
  brandName: "Stella + Poppy",
  imageUrl:
    "https://cdn.faire.com/fastly/3a1b38e902911e656be1c7c6cadcab69d9328abd67e9dec63bcd54b9bd20a4cf.jpeg",
  priceDollars: 9,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7637cdc1236bf485d8b8bfad0b8f046dbbb0a26ba85a6dc60554c0dcf6f16611.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
